import { useEffect, useRef, type Dispatch, type SetStateAction } from "react";
import { syncRecipientDefault } from "./syncRecipientDefault";

/** Keep open previews current without resetting the user's extra recipients. */
export const useLiveRecipientDefaults = ({
  open,
  email,
  phone,
  setEmails,
  setPhones,
}: {
  open: boolean;
  email: string;
  phone: string;
  setEmails: Dispatch<SetStateAction<string[]>>;
  setPhones: Dispatch<SetStateAction<string[]>>;
}) => {
  const previous = useRef({ email, phone });
  useEffect(() => {
    const before = previous.current;
    previous.current = { email, phone };
    if (!open) return;
    if (before.email !== email)
      setEmails((current) =>
        syncRecipientDefault(current, before.email, email, "email"),
      );
    if (before.phone !== phone)
      setPhones((current) =>
        syncRecipientDefault(current, before.phone, phone, "phone"),
      );
  }, [open, email, phone, setEmails, setPhones]);
};
